import { render, staticRenderFns } from "./CalendarServices.vue?vue&type=template&id=52b5eaee&"
import script from "./CalendarServices.vue?vue&type=script&lang=ts&"
export * from "./CalendarServices.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarServices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports